import { render, staticRenderFns } from "./JumpDialog.vue?vue&type=template&id=65922b46&scoped=true"
import script from "./JumpDialog.vue?vue&type=script&lang=js"
export * from "./JumpDialog.vue?vue&type=script&lang=js"
import style0 from "./JumpDialog.vue?vue&type=style&index=0&id=65922b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65922b46",
  null
  
)

export default component.exports